import { Breakpoints, Colors, Margins } from 'src/constants'
import styled from 'styled-components'

export const WalletInterfaceContainer = styled.div`
  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    width: 320px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    width: 450px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    width: 550px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET}px) {
    width: 600px;
  }
`

export const Text = styled.div`
  color: ${Colors.WHITE};

  font-size: 18px;

  @media only screen and (min-width: ${Breakpoints.TABLET}px) {
    font-size: 20px;
  }
`

export const WalletSelectButton = styled.div<{
  selected?: boolean
  disabled?: boolean
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(180deg, #37364c 0%, #302f41 100%);
  padding: ${Margins.s}px ${Margins.m}px ${Margins.s}px ${Margins.m}px;

  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};

  border-radius: 15px;
  ${(p) =>
    p.selected
      ? `background: unset; background-color: ${Colors.BLUE} !important;`
      : ``}

  &: hover {
    ${(p) =>
      p.disabled ? '' : `background: unset;background-color: ${Colors.BLUE};`}
  }

  @media only screen and (max-width: ${Breakpoints.MOBILE}px) {
    height: 40px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    height: 60px;
  }
`

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 1);
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 20px;
`
